import { coreEngine, time, nodes, addChildListener } from "@dinahmoe/dmafjs-core";
import { VisualSuper } from "./visual-super.component.js";

class Group extends VisualSuper {
  namespace = "visual:group";

  init(node, event) {
    super.init(node, event);


    if (node.props["children"] && node.props["children"].length > 0) {
      node.props["children"].map((element) => {
        return coreEngine.create({ ...element, parentUid: node.uid }, event);
      });
    }

    // Only index ids if this node was marked as such during instantiation
    if (node["indexIds"]) {
      this._indexIds(node);
    }
  }

  indexIds(cNode) {
    cNode["indexIds"] = true;
    this._indexIds(cNode);
  }

  _getChildById(cNode, id) {
    const childrenMap = nodes.getChildrenFor(cNode.uid);

    if (childrenMap.size === 0) {
      return;
    }
    for (const [, child] of childrenMap) {
      if (child["id"] === id || child.uid === id) {
        return child;
      }
    }

    for (const [, child] of childrenMap) {
      const elementWithId = this._getChildById(child, id);
      if (elementWithId) {
        return elementWithId;
      }
    }
  }




  _indexIds(node, rootNode = null) {
    // Recursively index all descendants with ids into the root node's _ids object
    // This creates a flat lookup table where root._ids[id] = childNode
    const root = rootNode || node;

    // Initialize _ids if it doesn't exist
    if (!root._ids) {
      root._ids = {};
    }

    // Only clean up and rebuild if this is the root call (not a recursive call)
    if (!rootNode) {
      // Track current ids in the tree
      const currentIds = new Set();
      this._collectIds(node, currentIds);

      // Remove stale entries that are no longer in the tree
      for (const id in root._ids) {
        if (!currentIds.has(id)) {
          delete root._ids[id];
        }
      }
    }

    const childrenMap = nodes.getChildrenFor(node.uid);

    if (childrenMap.size === 0) {
      return;
    }

    for (const [, child] of childrenMap) {
      if (child["id"]) {
        // Only add if not already indexed
        if (!root._ids[child["id"]]) {
          // Store reference to child in root's id index
          root._ids[child["id"]] = child;
          // Set up bridge listener so root receives env messages from this child
          // This enables centralized message handling at the root level
          addChildListener(child, root.uid);
        }
      }
      // Stop recursing if child indexes its own ids (encapsulation boundary)
      if (!child["indexIds"]) {
        this._indexIds(child, root);
      }
    }
  }

  _collectIds(node, idsSet) {
    // Recursively collect all ids currently in the tree
    const childrenMap = nodes.getChildrenFor(node.uid);

    if (childrenMap.size === 0) {
      return;
    }

    for (const [, child] of childrenMap) {
      if (child["id"]) {
        idsSet.add(child["id"]);
      }
      // Stop recursing if child indexes its own ids (encapsulation boundary)
      if (!child["indexIds"]) {
        this._collectIds(child, idsSet);
      }
    }
  }

  destroyHierarchy(cNode, event) {
    if (!event.time || event.time === 0) {
      coreEngine.destroy(cNode.uid);
    } else {
      time.schedule(event.time, () => {
        coreEngine.destroy(cNode.uid);
      });
    }
  }
}

const group = new Group();
export { Group, group };
